import axios from "axios";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
const fallbackBackendUrl = process.env.NODE_ENV === "development" ? "http://localhost:8080" : "";
const BACKEND_URL = (configuredBackendUrl || fallbackBackendUrl).replace(/\/+$/, "");

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
